import "./repo.a5e9c946.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecaa2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecaa2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lsboS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e50e5a44fb11e0$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $b4WUK.default)("ArrowRight", [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
]);

});

parcelRegister("ki04U", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec558c98a508af21$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $ec558c98a508af21$export$2e2bcd8739ae039 = (0, $b4WUK.default)("Clock3", [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "polyline",
        {
            points: "12 6 12 12 16.5 12",
            key: "1aq6pp"
        }
    ]
]);

});

parcelRegister("gRgf3", function(module, exports) {

$parcel$export(module.exports, "PageHero", () => $5405cac3ced8ac70$export$4b2976b57d220ac6);

var $ayMG0 = parcelRequire("ayMG0");
function $5405cac3ced8ac70$export$4b2976b57d220ac6({ kicker: kicker, title: title, lead: lead, image: image, imageAlt: imageAlt = '', children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
        className: "page-hero",
        children: [
            image && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-hero-media",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: image,
                        alt: imageAlt
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "page-shell page-hero-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        className: "eyebrow eyebrow-light reveal is-visible",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                "aria-hidden": "true"
                            }),
                            " ",
                            kicker
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "reveal is-visible",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "page-hero-lead reveal is-visible",
                        children: lead
                    }),
                    children && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "page-hero-extra reveal is-visible",
                        children: children
                    })
                ]
            })
        ]
    });
}

});


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $ayMG0 = parcelRequire("ayMG0");

var $lsboS = parcelRequire("lsboS");
var $03hdr = parcelRequire("03hdr");
var $ki04U = parcelRequire("ki04U");
var $voOPz = parcelRequire("voOPz");
var $7RdtG = parcelRequire("7RdtG");
var $hipFw = parcelRequire("hipFw");/**
 * @license lucide-react v0.468.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $b4WUK = parcelRequire("b4WUK");
const $077a0d6ca8d10e39$export$2e2bcd8739ae039 = (0, $b4WUK.default)("MessagesSquare", [
    [
        "path",
        {
            d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z",
            key: "p1xzt8"
        }
    ],
    [
        "path",
        {
            d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1",
            key: "1cx29u"
        }
    ]
]);



var $clpju = parcelRequire("clpju");

var $5xqgC = parcelRequire("5xqgC");

var $gRgf3 = parcelRequire("gRgf3");

var $3ua1s = parcelRequire("3ua1s");

var $gb7Gf = parcelRequire("gb7Gf");
const $798237c7fbf6d8f3$var$contactCards = [
    {
        icon: (0, $voOPz.default),
        title: 'Facebook',
        text: "Nuestro canal principal: transmisiones, anuncios y mensajes. Escr\xedbenos por Messenger.",
        action: 'Enviar mensaje',
        href: (0, $gb7Gf.facebookUrl),
        featured: true
    },
    {
        icon: (0, $7RdtG.default),
        title: 'Instagram',
        text: "El d\xeda a d\xeda de la comunidad: fotos, fragmentos y pr\xf3ximos eventos.",
        action: 'Seguir y escribir',
        href: (0, $gb7Gf.instagramUrl),
        featured: false
    },
    {
        icon: (0, $hipFw.default),
        title: "Ubicaci\xf3n",
        text: `${(0, $gb7Gf.churchAddress).street}, ${(0, $gb7Gf.churchAddress).locality}. Abre la ruta en Google Maps.`,
        action: "C\xf3mo llegar",
        href: (0, $gb7Gf.mapUrl),
        featured: false
    }
];
function $798237c7fbf6d8f3$export$ae9b91c35004859f() {
    (0, $3ua1s.useReveal)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $5xqgC.Layout), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $gRgf3.PageHero), {
                kicker: "Contacto",
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        "Hablemos, ",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("em", {
                            children: "estamos cerca"
                        }),
                        "."
                    ]
                }),
                lead: "\xbfTienes una pregunta, una petici\xf3n de oraci\xf3n o quieres visitarnos? Escr\xedbenos por nuestras redes; respondemos con gusto.",
                image: (0, $clpju.imgAlcanceCartel),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                    className: "button button-gold",
                    href: (0, $gb7Gf.facebookUrl),
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $077a0d6ca8d10e39$export$2e2bcd8739ae039), {
                            size: 18,
                            "aria-hidden": "true"
                        }),
                        " Escr\xedbenos por Facebook"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space",
                "aria-labelledby": "channels-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "section-heading reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                            className: "section-kicker",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                                " Canales directos"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            id: "channels-title",
                                            children: "Elige c\xf3mo contactarnos."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: "Facebook es nuestro canal principal: ah\xed estamos atentos durante toda la semana."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "contact-grid",
                            children: $798237c7fbf6d8f3$var$contactCards.map(({ icon: Icon, title: title, text: text, action: action, href: href, featured: featured })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: `contact-card reveal ${featured ? 'is-featured' : ''}`,
                                    href: href,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            className: "contact-card-icon",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                                                size: 26,
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            children: text
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                            className: "contact-card-action",
                                            children: [
                                                action,
                                                " ",
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03hdr.default), {
                                                    size: 18,
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    ]
                                }, title))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                className: "section-space contact-info-section",
                "aria-labelledby": "info-title",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "page-shell contact-info-layout",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "contact-info reveal",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                    className: "section-kicker",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {}),
                                        " Antes de escribir"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    id: "info-title",
                                    children: "Quiz\xe1s esto te ayude."
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                    className: "contact-facts",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ki04U.default), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Servicios"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                                            children: (0, $gb7Gf.services).map((service)=>`${service.day} ${service.time}`).join(" \xb7 ")
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hipFw.default), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "Direcci\xf3n"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                (0, $gb7Gf.churchAddress).street,
                                                                ", ",
                                                                (0, $gb7Gf.churchAddress).locality
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $077a0d6ca8d10e39$export$2e2bcd8739ae039), {
                                                    size: 20,
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                                            children: "\xbfPrimera vez?"
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            children: [
                                                                "Revisa la ",
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                                                    className: "text-link",
                                                                    href: "/visita/",
                                                                    children: "gu\xeda de tu visita"
                                                                }),
                                                                ": qu\xe9 esperar, horarios y preguntas frecuentes."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                    className: "button button-primary",
                                    href: "/visita/",
                                    children: [
                                        "Planifica tu visita ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lsboS.default), {
                                            size: 18,
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "location-map reveal",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                title: "Mapa de Iglesia Cristiana Tercer Cielo",
                                src: (0, $gb7Gf.mapEmbedUrl),
                                loading: "lazy",
                                referrerPolicy: "no-referrer-when-downgrade",
                                allowFullScreen: true
                            })
                        })
                    ]
                })
            })
        ]
    });
}



const $26559db93cd3a190$var$container = document.getElementById('app');
(0, $aRPiL.createRoot)($26559db93cd3a190$var$container).render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $acw62.StrictMode), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $798237c7fbf6d8f3$export$ae9b91c35004859f), {})
}));


//# sourceMappingURL=contacto.abc01c2f.js.map
